"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontendUpdateTracker = void 0;
const tiny_emitter_1 = require("tiny-emitter");
const source_frontend_update_tracker_1 = require("./source-frontend-update-tracker");
class FrontendUpdateTracker {
    constructor({ sourceUrlList, intervalMs = 30000 }) {
        this.emitter = new tiny_emitter_1.TinyEmitter();
        if (!sourceUrlList.length) {
            throw new Error('Discovery service URL is required');
        }
        this.trackers = sourceUrlList.map(sourceUrl => new source_frontend_update_tracker_1.SourceFrontendUpdateTracker({ sourceUrl, intervalMs }));
    }
    onUpdate(handler) {
        this.emitter.on('update', handler);
    }
    onError(handler) {
        this.emitter.on('error', handler);
    }
    start() {
        for (const tracker of this.trackers) {
            if (tracker.initialized) {
                continue;
            }
            tracker.onUpdate((differenceVersions) => this.emitUpdate(differenceVersions));
            tracker.onError((error) => this.emitError(error));
            tracker.start()
                .catch((error) => {
                this.emitError(error);
            });
        }
    }
    emitUpdate(differenceVersions) {
        this.emitter.emit('update', differenceVersions);
    }
    emitError(error) {
        this.emitter.emit('error', error);
    }
}
exports.FrontendUpdateTracker = FrontendUpdateTracker;
